import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useInstitute } from "../context/InstituteContext";

export default function InstituteTopbar() {
  const navigate = useNavigate();
  const { currentInstitute, logout } = useInstitute();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDown = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const name = currentInstitute?.name || "Institute";

  return (
    <div className="admin-topbar d-flex justify-content-between align-items-center gap-3">
      <div>
        <div className="fw-bold" style={{ color: "var(--oes-navy)" }}>{name}</div>
        <div className="text-muted small">{currentInstitute?.email}</div>
      </div>

      <div className="admin-topbar-dropdown" ref={ref}>
        <button
          type="button"
          className="admin-topbar-user-btn"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          <div className="admin-topbar-avatar">{name.trim().charAt(0).toUpperCase()}</div>
          <span className="admin-topbar-name d-none d-sm-inline">{currentInstitute?.contact || name}</span>
          <i className="bi bi-chevron-down admin-topbar-chevron" />
        </button>
        {open && (
          <div className="admin-topbar-menu">
            <button
              className="admin-topbar-menu-item admin-topbar-menu-item-danger"
              onClick={() => {
                logout();
                navigate("/login");
              }}
            >
              <i className="bi bi-box-arrow-right me-2" /> Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}